import React, { useState } from 'react';

/** Renders the node_id + api_key + token reveal panel. Used by both
 *  AddNodeModal (post-provision reveal) and NodeCredentialsModal
 *  (lookup-existing flow). Show/Hide on the token, per-field Copy
 *  buttons, and a single "Copy as api-config.yml fragment" shortcut.
 *
 *  Props:
 *    credentials: { node_id, api_key, token }
 *    warning?: optional banner string above the rows
 */
export default function NodeCredentialsPanel({ credentials, warning }) {
  const [copiedField, setCopiedField] = useState(null);

  const copy = (label, value) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopiedField(label);
      setTimeout(() => setCopiedField(null), 2000);
    });
  };

  const yamlFragment = (r) =>
    `node:\n  api_key: ${r.api_key}\n  token: ${r.token}\n  connect_url: ws://rendezvous:9000/connect\n`;

  return (
    <div>
      {warning && <div style={warnBoxStyle}>{warning}</div>}
      <CredentialRow label="node_id" value={String(credentials.node_id)} copy={copy} copied={copiedField === 'node_id'} />
      <CredentialRow label="api_key" value={credentials.api_key || ''} copy={copy} copied={copiedField === 'api_key'} mono />
      <CredentialRow label="token" value={credentials.token || ''} copy={copy} copied={copiedField === 'token'} mono secret />
      <div style={{ marginTop: 16 }}>
        <button type="button" onClick={() => copy('yaml', yamlFragment(credentials))} style={buttonSecondaryStyle}>
          {copiedField === 'yaml' ? 'Copied ✓' : 'Copy as api-config.yml fragment'}
        </button>
      </div>
    </div>
  );
}

function CredentialRow({ label, value, copy, copied, mono, secret }) {
  const [revealed, setRevealed] = useState(!secret);
  const displayValue = revealed ? value : '•'.repeat(Math.min(value.length, 32));
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ color: '#666', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>{label}</div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <code style={{ flex: 1, padding: '6px 10px', background: '#f5f5f5', borderRadius: 4,
                       fontFamily: mono ? 'ui-monospace, monospace' : 'inherit',
                       fontSize: mono ? '0.82rem' : '0.9rem', wordBreak: 'break-all' }}>
          {displayValue}
        </code>
        {secret && (
          <button type="button" onClick={() => setRevealed((r) => !r)} style={tinyButtonStyle}>
            {revealed ? 'Hide' : 'Show'}
          </button>
        )}
        <button type="button" onClick={() => copy(label, value)} style={tinyButtonStyle}>
          {copied ? '✓' : 'Copy'}
        </button>
      </div>
    </div>
  );
}

const buttonSecondaryStyle = {
  padding: '8px 16px', background: 'transparent', color: '#5fa67a',
  border: '1px solid #5fa67a', borderRadius: 4, fontSize: '0.85rem', cursor: 'pointer',
};
const tinyButtonStyle = {
  padding: '4px 10px', background: '#fff', border: '1px solid #ccc',
  borderRadius: 4, fontSize: '0.75rem', cursor: 'pointer',
};
const warnBoxStyle = {
  background: '#fff3cd', color: '#664d03', padding: 10, borderRadius: 4,
  fontSize: '0.85rem', marginBottom: 16,
};
